import { Controller } from "@hotwired/stimulus"

/**
 * Toggles between single-value and range inputs for numeric filters
 * based on the selected operator (e.g. "between" shows min/max).
 *
 * Connects to data-controller="number-filter"
 *
 * Usage:
 *   <div data-controller="number-filter" data-number-filter-op-value="eq">
 *     <select data-number-filter-target="op"
 *             data-action="change->number-filter#switchMode">
 *       <option value="eq">=</option>
 *       <option value="between">Between</option>
 *     </select>
 *     <span data-number-filter-target="single">
 *       <input type="number" />
 *     </span>
 *     <span data-number-filter-target="range" class="hidden">
 *       <input type="number" placeholder="Min" />
 *       <input type="number" placeholder="Max" />
 *     </span>
 *   </div>
 */
export default class extends Controller {
  static targets = ["op", "single", "range"]
  static values = {
    op: { type: String, default: "eq" },
  }

  declare readonly opTarget: HTMLSelectElement
  declare readonly singleTarget: HTMLElement
  declare readonly rangeTarget: HTMLElement
  declare readonly opValue: string

  connect() {
    this.switchMode()
  }

  switchMode() {
    const op = this.opTarget.value

    if (op === "between") {
      this.singleTarget.classList.add("hidden")
      this.rangeTarget.classList.remove("hidden")
    } else {
      this.singleTarget.classList.remove("hidden")
      this.rangeTarget.classList.add("hidden")
    }
  }
}
